export default __webpack_public_path__ + "22.png";